import { Action } from "redux";

export const VIEW_TYPE_CHANGED = "VIEW_TYPE_CHANGED";

export interface UpdateViewTypeAction extends Action {
    viewType: string;
}

export const updateViewTypeAction = (viewType: string): UpdateViewTypeAction => {
    return {
        type: "VIEW_TYPE_CHANGED",
        viewType: viewType,
    };
};
